<template>
    <q-page>
        <div class="q-display-1">Chat</div>

        <q-chat-message
            :label='new Date().toLocaleDateString()'
        />

        <q-chat-message
            name="Piotr"
            :text="['Cześć', 'Jesteś tam?']"
            stamp="7 minut temu"
        />

        <q-chat-message
            name="Ja"
            :text="['Cześć Piotrze']"
            stamp="2 minuty temu"
            sent
        />

        <q-chat-message
            name="Ja"
            :text="['jestem, co słychać?']"
            stamp="przed chwilą"
            sent
        />
    </q-page>
</template>

<script>
    export default {
        name: 'Chat'
    }
</script>